'use client';

export default function useScrollToView(
  target: string,
  behavior: ScrollBehavior = 'smooth',
  offset = 0,
  updateHash = false,
): Promise<void> | undefined {
  if (typeof window === 'undefined') {
    return undefined;
  }

  const element = document.getElementById(target);

  if (updateHash) window.history.pushState(null, '', `#${target}`);

  if (!element) return undefined;
  const y = element.getBoundingClientRect().top + window.scrollY - offset;

  setTimeout(() => {
    window.scrollTo({ top: y, behavior: behavior });
  }, 150);

  return new Promise(resolve => {
    const scrollHandler = () => {
      if (Math.floor(y) === Math.floor(window.scrollY)) {
        window.removeEventListener('scroll', scrollHandler);
        resolve();
      }
    };
    window.addEventListener('scroll', scrollHandler);
  });
}
